define( 'ANSI/UIComponents/Buttons',[ 'jquery', 'ANSI/Utility/SitecoreUtils' ], function ( $, sitecoreUtils ) {
    'use-strict';

    var ansiScrollButton = function ansiScrollButton() {
        var scrollBtn = document.querySelector( '.ansi-scroll-button' );
        scrollBtn.addEventListener( 'click', function ( e ) {
            e.preventDefault();
            var btnOffset = offset( scrollBtn );
            window.scroll( {
                top: btnOffset.top - 68,
                behavior: 'smooth'
            } );
        } );
    };
    var offset = function offset( el ) {
        var rect = el.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    };

    var backBtn = function backBtn() {
        var btn = document.querySelector( '.js-back' );
        btn.addEventListener( 'click', function ( e ) {
            e.preventDefault();
            window.history.back();
        } );
    };

    if ( !sitecoreUtils.prototype.isEditing() ) {
        if ( $( '.ansi-scroll-button' ).length > 0 ) {
            Promise.resolve().then( ansiScrollButton );
        }
        if ( $( '.js-back' ).length > 0 ) {
            Promise.resolve().then( backBtn );
        }
    }
} );;
